import React, { useState } from 'react'
import { Grid, Input, InputAdornment, TextField } from '@mui/material'
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { customStyles } from '../../../styles';

export const MainInput = ({ columns, visible = true, multiline=false, height, name, value, onChange, label, iconProps, icon, placeholder, type, disabled, sx, children, sx2, inputProps, className  }) => {

    const [readOnly, setReadOnly] = useState(true)
  return (
    <>
    {
        visible && 
        <Grid item xs={ columns } sx={{ borderRadius: 50, height: height, }}>
        <TextField 
            className={`input-radius ${className}` }
            name={name}
            value={value}
            onChange={onChange}
            label={ label }
            InputProps={{
                startAdornment: (
                <InputAdornment position="end" style={ iconProps }>
                    { icon }
                </InputAdornment>
                ),
            }}
            placeholder={placeholder}
            type={type}
            disabled={disabled}
            multiline={multiline}
            autoComplete="off"
            defaultValue=""
            // autoFocus={false}
            // onClick={ onClick }
            sx={{
                width: '100%',
                backgroundColor: customStyles.colors.backgroundColor,
                ...sx,
                'div': {
                    height: height,
                    ...sx2,

                    'input': {
                        ...inputProps,
                    }
                }
            }}
        />
        { children }
    </Grid>
    }
    </>
  )
}
